import React from 'react';

const Podaci = ({ sifra, tip, cena, kvadratura, sobe, kupatila, parking, namena, garaza, spratovi, namestenost }) => {
  return (
    <div className="relative w-full sm:w-[calc(100%-6cm)] mx-auto">
      {/* Naslov "Podaci" poravnat uz levu stranu */}
      <h2
        className="absolute top-0 left-0 text-xl font-bold text-white"
        style={{ zIndex: 10, marginTop: '-60px' }} // Ručno podešavanje margine
      >
        Podaci
      </h2>

      {/* Okvir i sadržaj */}
      <div
        className="bg-gray-800 p-6 rounded-lg shadow-lg border-2 border-pink-600"
        style={{ boxShadow: '0 0 15px 5px rgba(225, 0, 85, 0.8)' }} // Efekat isijavanja
      >
        <table className="w-full text-sm text-gray-300">
          <tbody>
            <tr>
              <td className="font-semibold py-2">Šifra oglasa</td>
              <td className="text-right py-2">{sifra}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Tip</td>
              <td className="text-right py-2">{tip}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Cena</td>
              <td className="text-right py-2">{cena} €</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Kvadratura</td>
              <td className="text-right py-2">{kvadratura} m²</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Sobe</td>
              <td className="text-right py-2">{sobe}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Broj kupatila</td>
              <td className="text-right py-2">{kupatila}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Parking</td>
              <td className="text-right py-2">{parking ? 'Da' : 'Ne'}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Namena</td>
              <td className="text-right py-2">{namena}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Garaža</td>
              <td className="text-right py-2">{garaza}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Broj spratova</td>
              <td className="text-right py-2">{spratovi}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2">Nameštenost</td>
              <td className="text-right py-2">{namestenost}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Podaci;
